import { useMutation } from '@tanstack/react-query';

import { useEnsureCsrfToken } from '~/context/CsrfContext';
import type { ToastData } from '~/hooks/useToast';

export type ReportPostResponse = { toast: ToastData };

const isReportPostResponse = (data: unknown): data is ReportPostResponse => {
  if (typeof data !== 'object' || data === null) return false;
  return 'toast' in data;
};

const useReportPostMutation = () => {
  const ensureCsrfToken = useEnsureCsrfToken();
  return useMutation({
    mutationFn: async (payload: { post_id: string; reason: string }): Promise<ReportPostResponse> => {
      const csrfToken = await ensureCsrfToken();
      const params = new URLSearchParams({ post_id: payload.post_id, reason: payload.reason });

      const response = await fetch('/report_community_post', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'X-CSRF-Token': csrfToken,
        },
        body: params,
      });

      const data: unknown = await response.json();
      if (!isReportPostResponse(data)) throw new Error('report_post_invalid_response');

      return data;
    },
  });
};

export default useReportPostMutation;
